export const LOGO_SRC = '/images/witmetrics_logo.svg';
